import { claimSubmit } from '../../claim';
import { ReduxThunkAction } from '../../redux/redux-actions';
import { IncomeManagementPlan } from '../reducer';

type SubmitReturn = Promise<any>;
export type Submit = (details: IncomeManagementPlan) => SubmitReturn;
type SubmitAction = (details: IncomeManagementPlan) => ReduxThunkAction<SubmitReturn>;
export const submitAction: SubmitAction = (incomeManagementPlan: IncomeManagementPlan) => {
    return async (dispatch, getState) => {
        return claimSubmit(dispatch, getState, claim => ({
            ...claim,
            incomeManagementPlan,
        }));
    };
};
